/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Sync_Status_StartingInputs */

const en_offline_sync_status_starting = /** @type {(inputs: Offline_Sync_Status_StartingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Starting transcription...`)
};

const fr_offline_sync_status_starting = /** @type {(inputs: Offline_Sync_Status_StartingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Démarrage de la transcription...`)
};

const de_offline_sync_status_starting = /** @type {(inputs: Offline_Sync_Status_StartingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transkription wird gestartet...`)
};

const it_offline_sync_status_starting = /** @type {(inputs: Offline_Sync_Status_StartingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avvio trascrizione...`)
};

const ru_offline_sync_status_starting = /** @type {(inputs: Offline_Sync_Status_StartingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Запуск транскрибации...`)
};

const es_offline_sync_status_starting = /** @type {(inputs: Offline_Sync_Status_StartingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iniciando transcripción...`)
};

const zh_cn2_offline_sync_status_starting = /** @type {(inputs: Offline_Sync_Status_StartingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在开始转写...`)
};

const ja_offline_sync_status_starting = /** @type {(inputs: Offline_Sync_Status_StartingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文字起こしを開始しています...`)
};

const hi_offline_sync_status_starting = /** @type {(inputs: Offline_Sync_Status_StartingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ट्रांसक्रिप्शन शुरू हो रहा है...`)
};

const pt_pt2_offline_sync_status_starting = /** @type {(inputs: Offline_Sync_Status_StartingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A iniciar transcrição...`)
};

/**
* | output |
* | --- |
* | "Starting transcription..." |
*
* @param {Offline_Sync_Status_StartingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const offline_sync_status_starting = /** @type {((inputs?: Offline_Sync_Status_StartingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Sync_Status_StartingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_offline_sync_status_starting(inputs)
	if (locale === "de") return de_offline_sync_status_starting(inputs)
	if (locale === "it") return it_offline_sync_status_starting(inputs)
	if (locale === "ru") return ru_offline_sync_status_starting(inputs)
	if (locale === "es") return es_offline_sync_status_starting(inputs)
	if (locale === "zh-CN") return zh_cn2_offline_sync_status_starting(inputs)
	if (locale === "ja") return ja_offline_sync_status_starting(inputs)
	if (locale === "hi") return hi_offline_sync_status_starting(inputs)
	if (locale === "pt-PT") return pt_pt2_offline_sync_status_starting(inputs)
	return en_offline_sync_status_starting(inputs)
});